import * as React from 'react';
import { DEFAULT_STATE } from './ugcAssignmentReducer';

export type UgcAssignmentContextShape = {
  assignments: typeof DEFAULT_STATE,
  requestAssignment: Function,
};

export default React.createContext({
  assignments: DEFAULT_STATE,
  requestAssignment: () => {},
});



// WEBPACK FOOTER //
// ./src/containers/client/UgcAssignmentContext.js